import { createApp } from 'vue'
import App from './App.vue';
import i18n from './i18n';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './assets/style.css';

export const app = createApp(App);
app.AOS = new AOS.init({/* disable: window.innerWidth < 350
,*/
    delay:50,
    duration: 500,
});
app.use(AOS).use(i18n).mount('#app');
